import { useEffect, useMemo } from 'react';

import Quiz from '../Quiz/Quiz';

import detectLang from '../../i18n/detectLang';

import styles from './Main.module.scss';

const Main = () => {
  const lang = useMemo(detectLang, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <div className={styles.main}>
      <Quiz lang={lang} />
    </div>
  );
};

export default Main;
